var map = {
	"./DiamondToNFT.js": 29715,
	"./Factory.js": 25680,
	"./Market.js": 86137,
	"./Moola.js": 18902,
	"./MultiRewards.js": 40620,
	"./NFTBox.js": 60304,
	"./OceanLandNft.js": 90970,
	"./OceannLand.js": 84743,
	"./Pair.js": 68862,
	"./Router.js": 63178,
	"./Staking.js": 76114,
	"./StakingRewards.js": 59496,
	"./erc20.js": 44610
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50357;